<template>
  <div id="app">
      <router-view/>
      <popup />
  </div>
</template>



<script>
import popup from "./components/popup";
export default {
  components: {
    popup
  },
}
  </script>
<style lang="less">

</style>
